import mitt from 'mitt'

// Создаем единственный экземпляр эмиттера для всего приложения
export const emitter = mitt()

// Для обратной совместимости с существующим EventBus
export default emitter
